import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import * as selectors from './interiorDesignSelectors';
import type {TInteriorDesignResultData, TInteriorTableState} from './types';

type InteriorDesignSlice = {
  output: null | TInteriorDesignResultData;
  tables: null | TInteriorTableState;
  applyToAll: boolean;
};

const initialState: InteriorDesignSlice = {
  output: null,
  tables: null,
  applyToAll: true,
};

const interiorDesignSlice = createSlice({
  name: 'interiorDesign',
  initialState,
  reducers: {
    setOutput: (
      state,
      {payload}: PayloadAction<{output: null | TInteriorDesignResultData}>,
    ) => {
      state.output = payload.output;
    },
    resetOutput: state => {
      state.output = initialState.output;
    },
    setApplyToAll: (state, {payload}: PayloadAction<{applyToAll: boolean}>) => {
      state.applyToAll = payload.applyToAll;
    },
    setTables: (
      state,
      {payload}: PayloadAction<{tables: null | TInteriorTableState}>,
    ) => {
      state.tables = payload.tables;
    },
  },
});

export default {
  ...interiorDesignSlice,
  selectors,
};
